"use strict";

angular.module('rmUser')
	.config(['$stateProvider', function ($stateProvider) {

    $stateProvider
        .state('user', {
            url: "/user",

            views: {

                'useroverview': {

                  	templateUrl: '/partial/app.partials.user.overview',
					controller: 'UserOverviewCtrl',
					controllerAs: 'userCtrl'
                },
                'userdetail': {

                    templateUrl: '/partial/app.panels.empty'
                }
            },

            onEnter: ['bladesManager', function( bladesManager ) {

                bladesManager.clearAll();
                bladesManager.insert({ viewName:'useroverview', size:'half' });
                bladesManager.insert({ viewName:'userdetail', size:'half' });
            }]
        })
        .state('user.update', {
            url: "/update/:id",
            views: {

                'userdetail@': {

                    templateUrl: '/partial/app.partials.user.detail',
					controller: 'UserFormCtrl',
					controllerAs: 'ctrl'
                }
            }
        }).state('user.profile', {
            url: '/profile',
            views: {

           	'userdetail@': {
					templateUrl: '/partial/app.partials.user.profile',
					controller: 'UserProfileCtrl',
					controllerAs: 'ctrl'
				}
            }
		}).state('user.invite', {
            url: '/invite',
            views: {

                 'userdetail@': {
					templateUrl: '/partial/app.partials.user.invite',
					controller: 'UserInviteCtrl',
					controllerAs: 'ctrl'
				}
            }
		}).state('profile', {
			url: "/profile",
			views: {
				'profile@': {
					templateUrl: '/partial/app.partials.user.profile',
					controller: 'UserProfileCtrl',
					controllerAs: 'ctrl'
				}
			},

            onEnter: ['bladesManager', function( bladesManager ) {

                bladesManager.clearAll();
                bladesManager.insert({ viewName:'profile', size:'half' });
            }]
		})
} ] );
